import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@repo/ui/components/Base/Dialog";
import { useState } from "react";
import { ReoccurringAgendaItemForm } from "./ReoccurringAgendaItemForm";
import type { AgendaItem } from "@repo/types";

export const ReoccurringAgendaItemDialog = ({
  tenantId,
  agendaItem,
  open: outerOpen,
  setOpen: outerSetOpen,
}: {
  tenantId: string;
  agendaItem: AgendaItem;
  open?: boolean;
  setOpen?: (open: boolean) => void;
}) => {
  const [innerOpen, innerSetOpen] = useState(false);

  const open = outerOpen ?? innerOpen;
  const setOpen = outerSetOpen ?? innerSetOpen;

  const handleOpenChange = () => setOpen(!open);

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent preventClickout preventEscape>
        <DialogHeader>
          <DialogTitle>Reoccurring Agenda Item</DialogTitle>
        </DialogHeader>
        <ReoccurringAgendaItemForm
          tenantId={tenantId}
          agendaItem={agendaItem}
          handleCancel={handleOpenChange}
          handleComplete={handleOpenChange}
          withinDialog
        />
      </DialogContent>
    </Dialog>
  );
};
